import React, { Component } from 'react';
import CompareMap from './compare_map';
import CloseIconBlue from '../../images/close-icon-blue.svg';
import Chevron from '../../images/chevron-down-white.svg';
import Slider from 'react-slick';
import I18n from '~/utils/translations';
import { respond, TABLET, DESKTOP, onResize, removeResize } from '~/utils/breakpoints';

const SliderArrow = ({ customClass, onClick, icon }) => {
  return (
    <div className={`compare-modal__slider-btn compare-modal__slider-${customClass}`} onClick={onClick}>
      <img className="compare-modal__slider-btn-icon" src={icon} alt={customClass} />
    </div>
  );
};

export default class CompareModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMaps: false,
      slidesToShow: 1,
    };
  }

  renderPropertyItemValue = (facetName, value) => {
    if (facetName === 'Bedrooms' && value < 1) {
      return 'Studio';
    }
    if (facetName === 'Size' && value) {
      return `${value} sqft`;
    }
    return value;
  };

  renderPropertyItemRow = (facetName, value) => {
    return (
      <div className="compare-modal__properties-item-row">
        <span className="compare-modal__properties-item-label">{facetName} </span>
        {this.renderPropertyItemValue(facetName, value)}
      </div>
    );
  };

  openMaps = () => {
    this.setState({ showMaps: !this.state.showMaps });
  };

  closeModalOnOverlayClick = (evt) => {
    if (evt.target.className === 'compare-modal') {
      this.props.handleCloseModal();
    }
  };

  closeModalOnEscapePress = (evt) => {
    if (evt.keyCode === 27) {
      this.props.handleCloseModal();
    }
  };

  setNumberOfSlidesToShow = () => {
    this.setState({ slidesToShow: this.numberOfSlidesToShow });
  };

  handlePropertyClick = () => {
    track_event('compare_home_view_home_info', 'clicked', 'compare_home_view_home_info');
  };

  componentDidMount() {
    onResize(this.setNumberOfSlidesToShow);
    document.addEventListener('keydown', this.closeModalOnEscapePress, false);
  }

  componentWillUnmount() {
    removeResize(this.setNumberOfSlidesToShow);
    document.addEventListener('keydown', this.closeModalOnEscapePress, false);
  }

  render() {
    const settings = {
      speed: 500,
      slidesToShow: this.numberOfSlidesToShow,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      prevArrow: <SliderArrow customClass="prev-btn" icon={Chevron} />,
      nextArrow: <SliderArrow customClass="next-btn" icon={Chevron} />,
    };
    return (
      <div className="compare-modal" onClick={this.closeModalOnOverlayClick}>
        <div className="compare-modal__close-button" onClick={this.props.handleCloseModal}>
          <img className="compare-modal__close-button-icon" src={CloseIconBlue} />
        </div>

        <div className="compare-modal__inner">
          <h2 className="compare-modal__title">Homes Comparison {this.props.comparedListings.length}/3</h2>

          <div className="compare-modal__slider">
            <Slider {...settings}>
              {this.props.comparedListings.map((listing, i) => {
                const {
                  id,
                  slug,
                  locale,
                  priceInPence,
                  imageUrl,
                  town,
                  neighbourhood,
                  bedrooms,
                  sqft,
                  displayAddress,
                } = listing;

                const price = `£${priceInPence / 100} pm`;

                return (
                  <div key={id} className="compare-modal__properties-item">
                    <div className="compare-modal__properties-item-header">
                      <div
                        className="compare-modal__properties-item-header-image"
                        style={{ backgroundImage: `url(${imageUrl})` }}
                      ></div>

                      <span className="compare-modal__properties-item-header-text">
                        {`${i + 1}. `}
                        {displayAddress}
                      </span>
                    </div>

                    <div className="compare-modal__properties-item-body">
                      {this.renderPropertyItemRow('Price', price)}
                      {this.renderPropertyItemRow('Area', neighbourhood || town)}
                      {this.renderPropertyItemRow('Bedrooms', bedrooms)}
                      {this.renderPropertyItemRow('Size', sqft)}
                    </div>
                    <a
                      className="compare-modal__home-info-button compare-modal__home-info-button--primary"
                      href={`/${locale}/homes/${slug}`}
                      target="_blank"
                      onClick={this.handlePropertyClick}
                    >
                      {I18n.t('pages.homes.comparison.view')}
                    </a>
                  </div>
                );
              })}
            </Slider>
          </div>
          <CompareMap comparedListings={this.props.comparedListings} />
        </div>
      </div>
    );
  }

  get numberOfSlidesToShow() {
    if (respond(DESKTOP - 1)) return 3;
    if (respond(TABLET - 1)) return 2;
    return 1;
  }
}
